import { createSlice } from "@reduxjs/toolkit";

export const permissionsData = [
  {
    title: "Role Management",
    category: "roleManagement",
    data: [
      {
        id: 1,
        sort_order: 1,
        value: "Role",
        label: "Role Management",
        children: [
          { id: 1, sort_order: 1, value: "View Role", label: "View Role" },
          { id: 2, sort_order: 2, value: "Create Role", label: "Create Role" },
          { id: 3, sort_order: 3, value: "Edit Role", label: "Edit Role" },
          { id: 4, sort_order: 4, value: "Delete Role", label: "Delete Role" },
        ],
      },
    ],
  },
  {
    title: "User Management",
    category: "userManagement",
    data: [
      {
        id: 2,
        sort_order: 2,
        value: "User",
        label: "User Management",
        children: [
          { id: 1, sort_order: 1, value: "View User", label: "View User" },
          { id: 2, sort_order: 2, value: "Create User", label: "Create User" },
          { id: 3, sort_order: 3, value: "Edit User", label: "Edit User" },
          { id: 4, sort_order: 4, value: "Delete User", label: "Delete User" },
        ],
      },
    ],
  },
  {
    title: "News Management",
    category: "newsManagement",
    data: [
      {
        id: 3,
        sort_order: 3,
        value: "News",
        label: "News Management",
        children: [
          { id: 1, sort_order: 1, value: "View News", label: "View News" },
          { id: 2, sort_order: 2, value: "Create News", label: "Create News" },
          { id: 3, sort_order: 3, value: "Edit News", label: "Edit News" },
          { id: 4, sort_order: 4, value: "Delete News", label: "Delete News" },
          {
            id: 5,
            sort_order: 5,
            value: "Approve/Reject News",
            label: "Approve/Reject News",
          },
        ],
      },
    ],
  },
  {
    title: "Notification Management",
    category: "notificationManagement",
    data: [
      {
        id: 4,
        sort_order: 4,
        value: "Notification",
        label: "Notification Management",
        children: [
          {
            id: 1,
            sort_order: 1,
            value: "View Notification",
            label: "View Notification",
          },
          {
            id: 2,
            sort_order: 2,
            value: "Create Notification",
            label: "Create Notification",
          },
          {
            id: 3,
            sort_order: 3,
            value: "Edit Notification",
            label: "Edit Notification",
          },
          {
            id: 4,
            sort_order: 4,
            value: "Delete Notification",
            label: "Delete Notification",
          },
        ],
      },
    ],
  },
  {
    title: "Ward Management",
    category: "wardManagement",
    data: [
      {
        id: 5,
        sort_order: 5,
        value: "Ward",
        label: "Ward Management",
        children: [
          { id: 1, sort_order: 1, value: "View Ward", label: "View Ward" },
          // { id: 2, sort_order: 2, value: "Create Ward", label: "Create Ward" },
          {
            id: 3,
            sort_order: 3,
            value: "Change Ward Councilor",
            label: "Change Ward Councilor",
          },
          {
            id: 5,
            sort_order: 4,
            value: "Approve/Reject Ward",
            label: "Approve/Reject Ward",
          },
        ],
      },
    ],
  },
  {
    title: "Incident Reports",
    category: "incidentManagement",
    data: [
      {
        id: 6,
        sort_order: 6,
        value: "Incident Reports",
        label: "Incident Reports",
        children: [
          {
            id: 1,
            sort_order: 1,
            value: "View Incident Reports",
            label: "View Incident Reports",
          },
        ],
      },
    ],
  },
  {
    title: "Councillor Profile",
    category: "counsilorManagement",
    data: [
      {
        id: 7,
        sort_order: 7,
        value: "Councillor",
        label: "Councillor Profile",
        children: [
          {
            id: 1,
            sort_order: 1,
            value: "View Councillor",
            label: "View Councillor",
          },
          {
            id: 2,
            sort_order: 2,
            value: "Create Councillor",
            label: "Create Councillor",
          },
          {
            id: 3,
            sort_order: 3,
            value: "Edit Councillor",
            label: "Edit Councillor",
          },
          {
            id: 4,
            sort_order: 4,
            value: "Delete Councillor",
            label: "Delete Councillor",
          },
        ],
      },
    ],
  },
  {
    title: "Initiative and Project",
    category: "projectManagement",
    data: [
      {
        id: 8,
        sort_order: 8,
        value: "Initiative & Project",
        label: "Initiative & Project",
        children: [
          {
            id: 1,
            sort_order: 1,
            value: "View project/initiative",
            label: "View Initiatives & project ",
          },
          {
            id: 2,
            sort_order: 2,
            value: "Create project/initiative",
            label: "Create Initiatives & project ",
          },
          {
            id: 3,
            sort_order: 3,
            value: "Edit project/initiative",
            label: "Edit Initiatives & project ",
          },
          {
            id: 4,
            sort_order: 4,
            value: "Delete project/initiative",
            label: "Delete Initiatives & project ",
          },
          {
            id: 5,
            sort_order: 5,
            value: "Approve/Reject project/initiative",
            label: "Approve/Reject Initiatives & project ",
          },
        ],
      },
    ],
  },
];

const initialState = {
  rolesData: [],
  isLoading: false,
  totalPageNo: 1,
  currentPageNo: 1,
  roleModal: false,
  permissionModal: false,
  editRole: false,
  selectedRole: null,
  selectedUser: null,
  selectedPermissions: [],
  roleDeleteModalOpen: false,
  rolePermissionViewOnly: false,

  roleDeleteLoading: false,
  rolesDataDropdown: [],
  permissionsData,
  permissionSettings: {
    roleManagement: [],
    userManagement: [],
    notificationManagement: [],
    newsManagement: [],
    wardManagement: [],
    incidentManagement: [],
    counsilorManagement: [],
    projectManagement: [],
  },
  roleDetails: [],
};

export const roleSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    clearPermissionSettings: (state) => {
      state.permissionSettings = {
        roleManagement: [],
        userManagement: [],
        notificationManagement: [],
        newsManagement: [],
        wardManagement: [],
        incidentManagement: [],
        counsilorManagement: [],
        projectManagement: [],
      };
    },
    setPermissionByCategory: (state, action) => {
      const { category, permissions } = action.payload;
      if (state.permissionSettings[category]) {
        state.permissionSettings[category] = permissions;
      }
    },
    savePermissions: (state, action) => {
      Object.keys(state.permissionSettings).forEach((category) => {
        state.permissionSettings[category] =
          action.payload[category] || state.permissionSettings[category];
      });
    },
    setRolesData: (state, action) => {
      state.rolesData = action.payload;
    },
    setRolesPermissionViewOnly: (state, action) => {
      state.rolePermissionViewOnly = action.payload;
    },
    setPermissionSettings: (state, action) => {
      state.permissionSettings = action.payload;
    },
    setRolesDataDropdown: (state, action) => {
      state.rolesDataDropdown = action.payload;
    },
    setRolesDetailsData: (state, action) => {
      state.roleDetails = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTotalPageNo: (state, action) => {
      state.totalPageNo = action.payload;
    },
    setCurrentPageNo: (state, action) => {
      state.currentPageNo = action.payload;
    },
    toggleRoleModal: (state, action) => {
      state.roleModal = action.payload;
    },
    togglePermissionModal: (state, action) => {
      state.permissionModal = action.payload;
    },
    setRoleDeleteModalOpen: (state, action) => {
      state.roleDeleteModalOpen = action.payload;
    },
    setEditRole: (state, action) => {
      state.editRole = action.payload;
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    clearSelectedRole: (state) => {
      state.selectedRole = null;
    },
    setSelectedPermissions: (state, action) => {
      state.selectedPermissions = action.payload;
    },
    clearSelectedPermissions: (state) => {
      state.selectedPermissions = [];
    },
    savePermissions: (state, action) => {
      state.selectedPermissions = action.payload; // This commits the local state to the Redux store
    },

    setRoleDeleteLoading: (state, action) => {
      state.roleDeleteLoading = action.payload;
    },
  },
});

export const {
  setRolesData,
  setRolesDetailsData,
  setLoading,
  setTotalPageNo,
  toggleRoleModal,
  togglePermissionModal,
  setEditRole,
  setSelectedRole,
  setSelectedPermissions,
  clearSelectedPermissions,
  clearSelectedRole,
  setSelectedUser,
  setRoleDeleteModalOpen,
  setCurrentPageNo,
  setPermissionByCategory,
  savePermissions,
  setRolesDataDropdown,
  setRoleDeleteLoading,
  setPermissionSettings,
  setRolesPermissionViewOnly,
  clearPermissionSettings,
} = roleSlice.actions;

export default roleSlice.reducer;
